import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorCodes } from '../../constants/pol.enums';
import { Store } from '@ngrx/store';
import { hideNavigation } from '../../layout/navigation/state/navigation.actions';
import { disableUserMenu } from '../../state/core.actions';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  route = inject(ActivatedRoute);
  store = inject(Store);

  errorCode: number;
  errorCodes = ErrorCodes;

  ngOnInit(): void {
    this.errorCode = this.route.snapshot.data.errorCode;

    if(this.errorCode === ErrorCodes.LoginFailed) {
      this.store.dispatch(hideNavigation({ shouldHide: true }));
      this.store.dispatch(disableUserMenu({ shouldDisable: true }));
    }
  }
}
